// extracted by mini-css-extract-plugin
export var GalleryItemContainingDiv = "ScrollingGallery-module--GalleryItemContainingDiv--c660b";
export var GalleryItemGatsbyImage = "ScrollingGallery-module--GalleryItemGatsbyImage--181fd";
export var container = "ScrollingGallery-module--container--d3ccf";